import cloneDeep from 'lodash/cloneDeep';
import { Layouts, Images } from '@/components/ui/charts/plotly/PlotlyHelpers';

// gives access to unit system, plotly chart
import ChartMiddlewareVue from '@/components/ui/charts/middleware/PlotlyChartMiddleware.vue';
import { ChartTypeEnum } from '@/components/ui/charts/ChartHelpers';
import { Enums } from '@flightscope/baseball-stats';

export default {
  name: 'SprayChart',

  extends: ChartMiddlewareVue,

  data() {
    return {
      adjustRanges: true,
      chartType: ChartTypeEnum.SPRAY_CHART.type,
      plotlyLayoutExtended: cloneDeep(Layouts.sprayChart),
    };
  },

  methods: {
    customMapping(converted) {
      this.plotlyData = converted.map(this.mapDefaultTraceSettings);

      let symbol = this.unitSymbolX(this.unitSystem.system);
      this.plotlyLayoutExtended.title.text = this.$vuetify.lang.t('$vuetify.reports.sprayChart');
      this.plotlyLayoutExtended.xaxis.title = `${this.xAxisTitle}, ${symbol}`;
      this.plotlyLayoutExtended.yaxis.title = `${this.yAxisTitle}, ${symbol}`;

      const image = process.env.VUE_APP_SPORT_TYPE === Enums.SportType.Baseball.key
      ? Images.baseballCourtBG
        : Images.softballCourtBg;

      let convertedCourtBg = {
        ...image,
        x: this.convertToCurrent(image.x, this.xAxisConversion).value,
        y: this.convertToCurrent(image.y, this.yAxisConversion).value,
        sizex: this.convertToCurrent(image.sizex, this.xAxisConversion).value,
        sizey: this.convertToCurrent(image.sizey, this.yAxisConversion).value,
      };

      this.plotlyLayoutExtended.images = [convertedCourtBg];

      this.plotlyLayoutExtended.colorway = this.getColorsFromSeries(this.plotlyData);

      if (this.hoverTextFormatter) {
        this.hoverTextFormatter(this.plotlyData);
      }
    },
  },
};
